import { css } from '@emotion/react'
import { ExternalStyles, Theme, useTheme } from 'bold-ui'
import { FilterExpandableContainer } from 'components/filter-expandable-container/FilterExpandableContainer'
import { MicroareasFilterTags } from 'view/visualizacaoTerritorial/components/filter/MicroareasFilterTags'
import { convertMicroareasFilterFormModelToFilterModel } from 'view/visualizacaoTerritorial/converter'
import { VisualizacaoMicroareasFilterFormModel } from 'view/visualizacaoTerritorial/model'

interface MapaBarraFiltrosAplicadosProps {
  appliedFilters: VisualizacaoMicroareasFilterFormModel | undefined
  style?: ExternalStyles
}

export function MapaBarraFiltrosAplicados(props: Readonly<MapaBarraFiltrosAplicadosProps>) {
  const { appliedFilters, style } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const convertedFilters = convertMicroareasFilterFormModelToFilterModel(appliedFilters)

  return (
    <div css={[styles.root, style]}>
      <FilterExpandableContainer resetDependency={appliedFilters}>
        <MicroareasFilterTags filter={convertedFilters} />
      </FilterExpandableContainer>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  root: css`
    display: flex;
    padding: 0.5rem 0.5rem 0.5rem 1rem;
    background: ${theme.pallete.surface.main};
    border-bottom: 1px solid ${theme.pallete.divider};
  `,
})
